import * as React from 'react';
import Button, { ButtonProps } from 'material-ui/Button/index';
import { CONSTANTS } from '../../assets/UIConstants';
import { CSSProperties } from 'react';

export class BigBlueButton extends React.Component<ButtonProps> {

    public render(): React.ReactNode {
        return (
            <Button
                {...this.props}
                size={'large'}
                style={{...buttonStyle, ...this.props.style}}
            >
                {this.props.children}
            </Button>
        );
    }
}

const buttonStyle: CSSProperties = {
    borderRadius: 60 + 'px',
    height: 60 + 'px',
    paddingTop: 10 + 'px',
    fontSize: 22 + 'px',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE,
    border: 'none',
    boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/BigBlueButton.tsx